/**
 * 第三方依赖 配置
 * - 全局性依赖
 * - vue第三方插件注册
 *
 * @since 1.0.0
 * @version 1.0.0
 */

import Vue from 'vue'
import 'normalize.css' // reset样式
import Antd, { message, notification, Modal } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import utils from '@/utils'

Vue.use(Antd)

Vue.prototype.$utils = utils
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$modal = Modal

window.process = {
  env: process.env,
  APP: process.APP,
  BUILD: process.BUILD,
}
